<template>
    <div>
        <i-form label-position="top">
            <vs-row>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center">
                    <h2>O sistema está liberado até {{this.date.format("DD-MM-YYYY")}}</h2>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center">
                <h2>{{message}}</h2>
                </vs-col>
                <vs-row>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
                        <form-item label="Alterar data de ativação do sistema para:">
                            <DatePicker type="date" placement="right-start" :options="options" v-model="form.period" format="dd/MM/yyyy" size="large" name="período" v-validate="'required'" @on-change="onChange"></DatePicker>
                        </form-item>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center">
                        <span class="text-danger text-sm pl-3" v-show="errors.has('período')">{{ errors.first('período') }}</span>
                    </vs-col>
                </vs-row>
                <vs-row v-if="logLiberacao.length > 0">
                  <vs-col>
                    <h2>Histórico de liberações manuais</h2>
                  </vs-col>
                  <vs-col>
                    <vx-table
                      :data="logLiberacao"
                      :columns="columns"
                    ></vx-table>
                  </vs-col>
                </vs-row>
            </vs-row>
        </i-form>
        <div class="floating-btn">
            <i-button v-show="show_save" @click="onSave" icon="md-checkmark" shape="circle" type="primary"></i-button>
        </div>
    </div>
</template>

<script>
import { moment } from '../../../helpers/utils'
export default {
    props:{
        data:Array,
        show_save:Boolean,
    },
    data:()=>({
        message:'',
        date: '',
        logLiberacao: [],
        options: {
            // range de 5 dias para escolha
            /*disabledDate (date) {
                return date && date.valueOf() < Date.now() || date.valueOf() > Date.now() + 432000000; //86400000 milsegundo coresponde a um dia
            }*/
        },
        form:{
            period: new moment().format("DD/MM/YYYY")
        },
    }),
    methods:{
        onSave(){
            this.$emit("input", this.form)
        },
        onChange(){
            this.$emit("change")
            this.show_button = true
        }
    },
    created() {
        if (typeof this.data[1].data_sistema_ativo === 'undefined') {
            this.message = 'Não foi possível obter dados da mensalidade'
        } else {
            let active_system_date = this.data[1].data_sistema_ativo
            let due_date = new moment(moment(active_system_date).format("YYYY-MM-DD"))
            this.date = due_date;
            let now = new moment(moment().format("YYYY-MM-DD"))
            let duration = due_date.diff(now)
            duration < 0 ? this.message = `Sistema venceu dia ${new moment(active_system_date).format("DD/MM/YYYY")}.` : this.message = 'Não existe mensalidade vencida.'

            if(this.data[1].log_liberacao_manual)
              this.logLiberacao = JSON.parse(this.data[1].log_liberacao_manual)
        }
    },
  computed: {
      columns(){
        return [
          {
            label: "Pessoa",
            key: "user",
            order: "asc",
            sortable: false,
          },
          {
            label: "Data Liberação",
            key: "date",
            order: "asc",
            sortable: false,
          }
        ]
      }
  }
}
</script>

<style lang="scss" scoped>
    h2{
        margin-bottom: 20px;
    }
    .ivu-form-item {
        width: 100%;
        margin: 10px;
    }
    .ivu-collapse {
        width: 100%;
    }
    .vs-col {
        margin: 0 0 10px 0;
    }
    .ivu-form-item {
        margin: 0;
    }
    .ivu-date-picker {
        width: 150px;
    }
</style>
